/* eslint-disable @typescript-eslint/no-explicit-any */
const containerInternal = new Map();
/**
 * Хранит общие экземпляры сервисов
 */
export const container = {
    get(name) {
        if (!this.has(name)) {
            throw new Error(`Instance ${name.toString()} not found in container`);
        }
        return containerInternal.get(name);
    },
    set(name, value) {
        if (containerInternal.has(name)) {
            throw new Error(`Instance ${name.toString()} already exist in container`);
        }
        containerInternal.set(name, value);
    },
    has(name) {
        return containerInternal.has(name);
    },
    delete(name) {
        return containerInternal.delete(name);
    },
};
